export default "__VITE_ASSET__C_R70izl__"